import { APP } from 'libs/constants';

export function isEligibleForTrial(user = {}, app = APP.muse) {
  const { introOfferEligible = [] } = user;
  return introOfferEligible.includes(app);
}

export default {
  isEligibleForTrial
};



// WEBPACK FOOTER //
// ./src/libs/musePlans.js